'use client';
import { useRouter } from '@bprogress/next';
import useBikes from '@util/hooks/useBikes';
import { serializeBike } from '@util/parseBikeName';
import { Make } from 'models/shared';
import React from 'react';
import Button from './Button';
import Select from './Select';

const DirtBikeSelector = () => {
  const [selectedBike, setSelectedBike] = React.useState({
    year: '',
    make: '',
    model: '',
  });
  const { bikeYears, bikeMakes, bikeModels } = useBikes(
    [selectedBike.year],
    [selectedBike.make] as Make[],
    ['Dirt Bikes']
  );
  const router = useRouter();
  return (
    <div className="mb-[5.2rem] flex w-full justify-center  sm:mb-[6.4rem]">
      <div className="flex w-full flex-col items-center justify-center gap-[1.6rem] md:flex-row">
        <div className="h-[4.4rem] w-full rounded-[0.6rem]  bg-[#F1F1F1] sm:w-[26.5rem]">
          <Select
            allowEmpty={false}
            placeholder="Select Year"
            options={bikeYears.map((year) => ({
              label: `${year}`,
              value: `${year}`,
              id: `${year}`,
            }))}
            value={selectedBike.year}
            onChange={(e) => {
              setSelectedBike({
                ...selectedBike,
                year: e.value,
              });
            }}
          />
        </div>
        <div className="h-[4.4rem] w-full rounded-[0.6rem] bg-[#F1F1F1] sm:w-[26.5rem]">
          <Select
            allowEmpty={false}
            placeholder="Select Make"
            options={bikeMakes.map((make) => ({
              label: `${make}`,
              value: `${make}`,
              id: `${make}`,
            }))}
            value={selectedBike.make}
            onChange={(e) => {
              setSelectedBike({
                ...selectedBike,
                make: e.value,
              });
            }}
          />
        </div>
        <div className="h-[4.4rem] w-full rounded-[0.6rem] bg-[#F1F1F1] sm:w-[26.5rem]">
          <Select
            allowEmpty={false}
            placeholder={
              selectedBike.make !== '' &&
              selectedBike.year !== '' &&
              bikeModels.length === 0
                ? 'No Bikes Found'
                : 'Select Model'
            }
            options={bikeModels.map((bike) => ({
              label: `${bike}`,
              value: `${bike}`,
              id: `${bike}`,
            }))}
            value={selectedBike.model}
            onChange={(e) => {
              setSelectedBike({
                ...selectedBike,
                model: e.value,
              });
            }}
            disabled={bikeModels.length === 0}
          />
        </div>
        <Button
          text="Find Parts"
          onClick={() => {
            const params = new URLSearchParams();
            let route = '/shop/oem-dirt-bike-parts';
            if (selectedBike.year && selectedBike.make && selectedBike.model) {
              params.set(
                'bikes',
                serializeBike({
                  year: Number(selectedBike.year),
                  make: selectedBike.make as Make,
                  model: selectedBike.model,
                })
              );
              route += `?${params.toString()}`;
            }
            router.push(route);
          }}
        />
      </div>
    </div>
  );
};

export default DirtBikeSelector;
